var fixtoInit;

(function ($) {

	const selectors = {
		box: '[data-fixto]',
		content: '[data-fixto-content]'
	}


	fixtoInit = function () {
		$(selectors.box).each((i, el) => {
			new Fixto(el);
		});
	}

	class Fixto {
		constructor(element) {
			this.box = element;
			this.content = $(selectors.content, this.box).get(0);

			if ($(this.content).length) {
				this.init();
			}

		}
		init() {

			const self = this;

			self.isActive = true;
			self.fromWidth = $(self.box).attr('data-from') ? parseInt($(self.box).attr('data-from')) : 0;

			self.offTop = window.scrollOffset ? window.scrollOffset : 0;
			self.offTop += $(self.box).attr('data-offset') ? parseInt($(self.box).attr('data-offset')) : 0;

			self.fixto = fixto.fixTo(this.content, this.box, {
				top: self.offTop,
				useNativeSticky: false,
				mind: '.c-top-bar'
			});

			this.bind();
			this.resize();
		}

		bind() {
			this.resize = this.resize.bind(this);
			$(window).on('resize', this.resize);
		}

		resize() {

			if (!this.fromWidth) return;
			if (window.outerWidth < this.fromWidth && this.isActive) {
				this.pause();
			}
			else if (window.outerWidth >= this.fromWidth && !this.isActive) {
				this.resume();
			}

		}

		pause() {
			this.isActive = false;
			this.fixto.stop();
		}

		resume() {
			this.isActive = true;
			this.fixto.start();

		}
	}

})(jQuery);


export default fixtoInit;